import React, { useEffect } from 'react';
import { Box, Container, Grid, Typography, Button, Card, CardContent, Avatar, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ShareIcon from '@mui/icons-material/Share';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CommentIcon from '@mui/icons-material/Comment';
import { Helmet } from 'react-helmet-async';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

export default function WebsiteDesigningSection() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });
  }, []);

  const features = [
    {
      title: "Modern UI Design",
      description: "Create stunning, responsive websites with cutting-edge design principles.",
      icon: "🎨",
      likes: "3.2K",
      comments: "245"
    },
    {
      title: "User Experience",
      description: "Design intuitive interfaces that provide seamless user interactions.",
      icon: "👥",
      likes: "2.9K",
      comments: "198"
    },
    {
      title: "Mobile Optimization",
      description: "Ensure your website looks and performs perfectly on all devices.",
      icon: "📱",
      likes: "3.4K",
      comments: "256"
    },
    {
      title: "Performance Focus",
      description: "Build fast-loading websites that deliver exceptional user experience.",
      icon: "⚡",
      likes: "2.8K",
      comments: "187"
    }
  ];

  const benefits = [
    "Enhanced user engagement",
    "Higher conversion rates",
    "Better brand perception",
    "Improved accessibility",
    "Faster load times",
    "SEO-friendly design"
  ];

  return (
    <>
    
<Box
  sx={{
    position: 'fixed',
    top: { xs: 50, sm: 70 },
    left: { xs: 12, sm: 24 },
    zIndex: 1200,
    bgcolor: 'white',
    borderRadius: '50%',
    boxShadow:5,
    width: { xs: 40, sm: 48 },
    height: { xs: 40, sm: 48 },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  <IconButton
    onClick={() => navigate(-1)}
    size="medium"
    sx={{
      color: '#1877f2',
      p: 0.5
    }}
  >
    <ArrowBackIosNewIcon fontSize="small" />
  </IconButton>
</Box>
      <Helmet>
        <title>Best Website Designing Company in Anakapalli & Visakhapatnam | SLGT Digital</title>
        <meta
          name="description"
          content="SLGT Digital is the top-rated website designing company in Anakapalli & Visakhapatnam. Responsive, SEO-friendly, conversion-focused web design for businesses in Vizag."
        />
        <meta
          name="keywords"
          content="Best Website Designing Company Anakapalli, Website Designing Visakhapatnam, Web Design Anakapalli, No.1 Web Design Services Vizag, Responsive Website Design Vizag, SEO Friendly Website Vizag, Business Website Designers Visakhapatnam, SLGT Digital Web Services"
        />
        <link rel="canonical" href="https://www.slgt.in/services/website-designing" />
        <meta property="og:title" content="Best Website Designing Company in Anakapalli & Visakhapatnam | SLGT Digital" />
        <meta property="og:description" content="Responsive, SEO-friendly, conversion-focused website design for businesses in Anakapalli & Visakhapatnam." />
        <meta property="og:url" content="https://www.slgt.in/services/website-designing" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.slgt.in/og.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Website Designing Services",
            "provider": {
              "@type": "Organization",
              "name": "SLGT Digital",
              "url": "https://www.slgt.in"
            },
            "areaServed": [
              { "@type": "City", "name": "Anakapalli" },
              { "@type": "City", "name": "Visakhapatnam" }
            ],
            "description": "Responsive, SEO-friendly, conversion-focused website design services for businesses in Anakapalli and Visakhapatnam.",
            "serviceType": "Web Design Service"
          })}
        </script>
      </Helmet>

      <Box sx={{ pt: { xs: 8, sm: 10 }, pb: { xs: 6, sm: 8 }, minHeight: '100vh', bgcolor: '#f8f9fa' }}>
        {/* Hero Section */}
        <Box sx={{ bgcolor: '#ffffff', color: '#2d3436', py: { xs: 6, md: 8 }, mb: { xs: 4, md: 6 }, boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
          <Container maxWidth="lg">
            <Grid container spacing={4} alignItems="center">
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                  <Avatar sx={{ width: 56, height: 56, mr: 2, bgcolor: '#0984e3' }}>
                    WD
                  </Avatar>
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#2d3436' }}>
                      Website Designing
                    </Typography>
                    <Typography sx={{ color: '#636e72', fontSize: '0.9rem' }}>
                      Professional Web Design Services
                    </Typography>
                  </Box>
                </Box>
                <Typography variant="h1" sx={{ fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' }, fontWeight: 700, mb: 3, color: '#2d3436', lineHeight: 1.2 }}>
                  Website Designing in Visakhapatnam
                </Typography>
                <Typography variant="body1" sx={{ fontSize: { xs: '1rem', sm: '1.1rem' }, mb: 4, color: '#636e72', lineHeight: 1.6 }}>
                  Is your website making an impact, or is it driving potential customers away? We create websites that are not just stunning but also strategic.
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => navigate('/requestquotes')}
                  sx={{ bgcolor: '#0984e3', color: 'white', '&:hover': { bgcolor: '#0773c5' }, px: { xs: 4, sm: 6 }, py: { xs: 1.5, sm: 2 }, fontSize: '1rem', fontWeight: 600, borderRadius: '6px', textTransform: 'none' }}
                >
                  Get Started
                </Button>
              </Grid>
              <Grid item xs={12} md={6} sx={{ display: { xs: 'none', md: 'block' } }}>
                <img
                  src="/assets/services/wd-1.jpg"
                  alt="Website Designing Illustration"
                  style={{ width: '100%', maxWidth: '500px', height: 'auto', margin: '0 auto', borderRadius: '8px' }}
                />
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* Features Section */}
        <Container maxWidth="lg" sx={{ mb: 8 }}>
          <Typography variant="h2" sx={{ fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' }, fontWeight: 700, mb: 6, textAlign: 'center', color: '#2d3436', lineHeight: 1.2 }}>
            Our Web Design Services
          </Typography>
          <Grid container spacing={3}>
            {features.map((feature, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <Card sx={{ height: '100%', borderRadius: '8px', boxShadow: '0 1px 2px rgba(0,0,0,0.1)', bgcolor: '#ffffff', border: '1px solid #dfe6e9', transition: 'transform 0.2s ease-in-out', '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' } }}>
                  <CardContent sx={{ p: 0 }}>
                    <Box sx={{ p: 2, borderBottom: '1px solid #dfe6e9' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar sx={{ width: 40, height: 40, mr: 2, bgcolor: '#0984e3' }}>{feature.icon}</Avatar>
                        <Box>
                          <Typography sx={{ fontWeight: 600, color: '#2d3436' }}>{feature.title}</Typography>
                          <Typography sx={{ fontSize: '0.9rem', color: '#636e72' }}>Professional Web Design Service</Typography>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{ p: 2 }}>
                      <Typography sx={{ color: '#2d3436', fontSize: '1rem', lineHeight: 1.6 }}>
                        {feature.description}
                      </Typography>
                    </Box>
                    <Box sx={{ p: 1, borderTop: '1px solid #dfe6e9', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton size="small" sx={{ color: '#0984e3' }}><FavoriteIcon /></IconButton>
                        <Typography sx={{ color: '#636e72', fontSize: '0.9rem' }}>{feature.likes}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton size="small" sx={{ color: '#636e72' }}><CommentIcon /></IconButton>
                        <Typography sx={{ color: '#636e72', fontSize: '0.9rem' }}>{feature.comments}</Typography>
                      </Box>
                      <IconButton size="small" sx={{ color: '#636e72' }}><ShareIcon /></IconButton>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* Benefits Section */}
        <Box sx={{ bgcolor: '#ffffff', py: 8 }}>
          <Container maxWidth="lg">
            <Typography variant="h2" sx={{ fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' }, fontWeight: 700, mb: 6, textAlign: 'center', color: '#2d3436', lineHeight: 1.2 }}>
              Benefits of Professional Web Design
            </Typography>
            <Grid container spacing={3}>
              {benefits.map((benefit, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card sx={{ height: '100%', borderRadius: '8px', boxShadow: '0 1px 2px rgba(0,0,0,0.1)', bgcolor: '#ffffff', border: '1px solid #dfe6e9', transition: 'transform 0.2s ease-in-out', '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' } }}>
                    <CardContent sx={{ p: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar sx={{ width: 40, height: 40, mr: 2, bgcolor: '#0984e3' }}>✓</Avatar>
                        <Typography sx={{ fontSize: '1rem', color: '#2d3436', fontWeight: 500 }}>{benefit}</Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        {/* CTA Section */}
        <Container maxWidth="lg" sx={{ mt: 8, textAlign: 'center' }}>
          <Card sx={{ borderRadius: '8px', boxShadow: '0 1px 2px rgba(0,0,0,0.1)', bgcolor: '#ffffff', p: 4 }}>
            <Typography variant="h2" sx={{ fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' }, fontWeight: 700, mb: 3, color: '#2d3436', lineHeight: 1.2 }}>
              Ready to Create Your Dream Website?
            </Typography>
            <Typography sx={{ mb: 4, fontSize: { xs: '1rem', sm: '1.1rem' }, maxWidth: '800px', mx: 'auto', color: '#636e72', lineHeight: 1.6 }}>
              Let's create a stunning website that represents your brand and drives business growth.
            </Typography>
            <Button
              variant="contained"
              onClick={() => navigate('/requestquotes')}
              sx={{ bgcolor: '#0984e3', color: 'white', '&:hover': { bgcolor: '#0773c5' }, px: 4, py: 2, fontSize: '1rem', fontWeight: 600, borderRadius: '6px', textTransform: 'none' }}
            >
              Request a Quote
            </Button>
          </Card>
        </Container>
      </Box>
    </>
  );
}
